<template>
  <div class="dcp-result-pagination">
    <div v-if="!hideProgressBar" data-test-id="dcp-pagination-progress-bar">
      <p class="dcp-result-pagination__label" data-test-id="dcp-result-pagination__label">
        {{
          $t(currentNumberLabel, {
            currentNumberOfItems,
            totalNumberOfItems: totalNumberOfResultsLimited || totalNumberOfItems,
          })
        }}
      </p>
      <div class="dcp-result-pagination__progress-bar dcp-result-pagination-progress-bar">
        <span
          class="dcp-result-pagination-progress-bar__indicator"
          data-test-id="dcp-result-pagination-progress-bar__indicator"
          :style="{ width: `${(currentNumberOfItems / totalNumberOfItems) * 100}%` }"
        >
        </span>
      </div>
    </div>
    <button
      v-if="buttonIsVisible"
      class="dcp-result-pagination__load-more wb-button wb-button--secondary wb-button--large"
      data-test-id="dcp-result-pagination__load-more"
      @click="loadMoreItems"
    >
      {{ $t(showMoreLabel) }}
    </button>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, toRefs } from 'vue';

export default defineComponent({
  name: 'ShowMoreButton',
  props: {
    currentNumberOfItems: {
      type: Number,
      required: true,
    },
    totalNumberOfItems: {
      type: Number,
      required: true,
    },
    totalNumberOfResultsLimited: {
      type: String,
      required: false,
    },
    currentNumberLabel: {
      type: String,
      required: true,
    },
    showMoreLabel: {
      type: String,
      required: true,
    },
  },

  emits: ['load'],

  setup(props, { emit }) {
    const { currentNumberOfItems, totalNumberOfItems } = toRefs(props);

    const buttonIsVisible = computed(() => currentNumberOfItems.value < totalNumberOfItems.value);

    const hideProgressBar = computed(() => currentNumberOfItems.value === totalNumberOfItems.value);

    const loadMoreItems = () => {
      emit('load');
    };

    return {
      buttonIsVisible,
      hideProgressBar,
      loadMoreItems,
    };
  },
});
</script>

<style src="./showMore.scss" lang="scss"></style>
